import SearchFilter from './SearchFilterContainer';
export default SearchFilter;
//# sourceMappingURL=index.js.map